import {useRef, useEffect, MutableRefObject} from 'react';

export function useDisableBodyScroll(isOpen: boolean, containerRef?: MutableRefObject<HTMLElement | null>): void {
    const previousOverflow: MutableRefObject<string> = useRef<string>('');

    useEffect(() => {
        const container = containerRef?.current || document.body;

        if (isOpen) {
            previousOverflow.current = window.getComputedStyle(container).overflow;
            container.style.overflow = 'hidden';
        } else if (previousOverflow.current) {
            container.style.overflow = previousOverflow.current;
        }

        return () => {
            if (isOpen && previousOverflow.current) {
                container.style.overflow = previousOverflow.current;
            }
        };
    }, [isOpen, containerRef]);
}
